import { foldersSaga } from '@store/reducers/dashboard/saga/folders'
import { all, takeEvery } from 'redux-saga/effects'

import { DashboardActions } from '../actions'
import { dashboardInit } from './dashboardInit'
import { membersSaga } from './members'
import { projectsSaga } from './projects'
import { statusesSaga } from './statuses'
import { teamsSaga } from './teams'

export function* dashboardSaga() {
  yield all([
    takeEvery(DashboardActions.init, dashboardInit),
    projectsSaga(),
    statusesSaga(),
    foldersSaga(),
    membersSaga(),
    teamsSaga(),
  ])
}
